import React, { Component } from 'react';

import { TextField } from 'react-md';

export default class GroupYouView extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

        this.generateOptions = this.generateOptions.bind(this);
    }

    generateOptions() {
        let result = [];

        result.push((
            <div className={"card-container"}>
                <div className={"label"}>{"Join a Group"}</div>
                <div className={"stack"}>
                    <TextField
                        id="group-join-textfield"
                        placeholder={"Enter Group Code"}
                        className={"group-text-input for-button" + (this.props.enteredGroupCode.length > 0 ? " mono" : "")}
                        value={this.props.enteredGroupCode}
                        onChange={this.props.setEnteredGroupCode}
                    />
                    <div className={"for-button-button" + (this.props.enteredGroupCode.length != 5 ? " disabled" : "")} onClick={this.props.submitScanCode}>{"Go"}</div>
                </div>
                
            </div>
        ));

        let joinGroupsJsx = []

        _.sortBy(this.props.yourGroups, x => x.name).forEach(group => {
            joinGroupsJsx.push((
                <div key={"group" + group.groupId} className={"card-item-outer" + (this.props.activeGroupId === group.groupId ? " active" : "")}>
                    <div className={"icon-container"} onClick={this.props.setMyActiveGroupId.bind(null, group.groupId)}>
                        <div className={"material-icons icon"}>{"group"}</div>
                    </div>
                    <div className={"name-container"} onClick={this.props.setMyActiveGroupId.bind(null, group.groupId)}>
                        <div className={"main-text"}>{group.name}</div>
                        <div className={"sub-text"}>{group.description}</div>
                    </div>
                    <div className={"bottom-container"}>
                        <div className={"material-icons bottom-item wide"} onClick={this.props.setManageActive.bind(null, true, false)}>{"edit"}</div>
                        <div className={"material-icons bottom-item wide"} onClick={this.props.deleteGroupMember.bind(null, group.name, "All", group.myLocationMemberIds)}>{"delete"}</div>
                    </div>
                </div>
            ));
        });

        if (joinGroupsJsx.length > 0) {
            joinGroupsJsx.unshift((<div className={"label"}>{"Joined Groups"}</div>));
            result.push((
                <div className={"card-container no-pad"}>
                    {joinGroupsJsx}
                </div>
            ));
        }

        let viewGroupsJsx = [];

        _.sortBy(this.props.viewGroups, x => x.name).forEach(group => {
            viewGroupsJsx.push((
                <div key={"group" + group.groupId} className={"card-item-outer" + (this.props.activeGroupId === group.groupId + "view" ? " active" : "")}>
                    <div className={"icon-container"} onClick={this.props.setMyActiveGroupId.bind(null, group.groupId + "view")}>
                        <div className={"material-icons icon"}>{"group"}</div>
                    </div>
                    <div className={"name-container"} onClick={this.props.setMyActiveGroupId.bind(null, group.groupId + "view")}>
                        <div className={"main-text"}>{group.name}</div>
                        <div className={"sub-text"}>{group.description}</div>
                    </div>
                    <div className={"bottom-container"}>
                        <div className={"material-icons bottom-item ultra-wide"} onClick={this.props.deleteGroupMember.bind(null, group.name, "yourself", group.myLocationMemberIds)}>{"delete"}</div>
                    </div>
                </div>
            ));
        });

        if (viewGroupsJsx.length > 0) {
            viewGroupsJsx.unshift((<div className={"label"}>{"Viewable Groups"}</div>));
            result.push((
                <div className={"card-container no-pad"}>
                    {viewGroupsJsx}
                </div>
            ));
        }

        return result;
    }

    render() {

        let optionsJsx = this.generateOptions();

        return (
            <div className={"group-main stackup-group-you-outer" + (this.props.isActive ? "" : " hidden") + (this.props.isCenter ? "" : " off")}>
                {optionsJsx}
            </div>
        );
    }
}

